// extracted by mini-css-extract-plugin
module.exports = {"container":"Confirmed__container--3OA2o"};